import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider, useDispatch } from 'react-redux';
import store from './redux/store';
import { fetchCurrentUser } from './redux/slices/authSlice';
import AppShell from './components/AppShell';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Organizations from './pages/Organizations';
import Roles from './pages/Roles';
import Users from './pages/Users';
import Employees from './pages/Employees';
import Leave from './pages/Leave';
import LeaveTypes from './pages/LeaveTypes';
import Holidays from './pages/Holidays';
import CTC from './pages/CTC';
import Documents from './pages/Documents';
import Payroll from './pages/Payroll';
import PayrollManagement from './pages/PayrollManagement';
import SalaryStructure from './pages/SalaryStructure';
import TaxDeclaration from './pages/TaxDeclaration';
import Attendance from './pages/Attendance';
import Settings from './pages/Settings';
import PayslipTemplateBuilder from './pages/PayslipTemplateBuilder';
import './styles/App.css';

function AppBootstrap() {
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem('token') || localStorage.getItem('authToken');
    if (token) {
      dispatch(fetchCurrentUser());
    }
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<AppShell><Dashboard /></AppShell>} />
        <Route path="/organizations" element={<AppShell><Organizations /></AppShell>} />
        <Route path="/roles" element={<AppShell><Roles /></AppShell>} />
        <Route path="/leave-types" element={<AppShell><LeaveTypes /></AppShell>} />
        <Route path="/users" element={<AppShell><Users /></AppShell>} />
        <Route path="/employees" element={<AppShell><Employees /></AppShell>} />
        <Route path="/ctc" element={<AppShell><CTC /></AppShell>} />
        <Route path="/documents" element={<AppShell><Documents /></AppShell>} />
        <Route path="/leaves" element={<AppShell><Leave /></AppShell>} />
        <Route path="/holidays" element={<AppShell><Holidays /></AppShell>} />
        <Route path="/payroll" element={<AppShell><PayrollManagement /></AppShell>} />
        <Route path="/salary-structure" element={<AppShell><SalaryStructure /></AppShell>} />
        <Route path="/tax-declaration" element={<AppShell><TaxDeclaration /></AppShell>} />
        <Route path="/attendance" element={<AppShell><Attendance /></AppShell>} />
        <Route path="/settings" element={<AppShell><Settings /></AppShell>} />
        <Route path="/payslip-templates" element={<AppShell><PayslipTemplateBuilder /></AppShell>} />
        <Route path="/" element={<AppShell><Dashboard /></AppShell>} />
      </Routes>
    </Router>
  );
}

function App() {
  return (
    <Provider store={store}>
      <AppBootstrap />
    </Provider>
  );
}

export default App;
